import * as React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { Button, Grid, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import ArchiveIcon from '@mui/icons-material/Archive';
import { useSelector } from 'react-redux';
import { IReduxState } from '../../store';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { IListeTuteur } from './Add';

interface Data {
    id: number;
    destinataire: string;
    title: number;
    message: number;
}


function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

type Order = 'asc' | 'desc';

function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key,
): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string },
) => number {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
// function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number) {
//     const stabilizedThis = array?.map((el, index) => [el, index] as [T, number]);
//     stabilizedThis.sort((a, b) => {
//         const order = comparator(a[0], b[0]);
//         if (order !== 0) {
//             return order;
//         }
//         return a[1] - b[1];
//     });
//     return stabilizedThis.map((el) => el[0]);
// }

interface HeadCell {
    disablePadding: boolean;
    id: string;
    label: string;
    numeric: boolean;
}



interface EnhancedTableProps {
    numSelected: number;
    onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
    filteredListeTuteurs: any;
}

function EnhancedTableHead(props: EnhancedTableProps) {
    const { onSelectAllClick, order, orderBy, numSelected, filteredListeTuteurs, rowCount, onRequestSort } =
        props;

    const headCells: readonly HeadCell[] = [
        {
            id: 'codeEtab',
            numeric: false,
            disablePadding: true,
            label: `Selection: (${numSelected} / ${filteredListeTuteurs.length})`,
        }
    ];

    const createSortHandler =
        (property: any) => (event: React.MouseEvent<unknown>) => {
            onRequestSort(event, property);
        };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                </TableCell>
                {headCells?.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={"left"}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

interface EnhancedTableToolbarProps {
    numSelected: number;
    search: any;
    setSearch: any;
    handleChange: any;
    value: any;
}

function EnhancedTableToolbar(props: EnhancedTableToolbarProps) {
    const { numSelected, search, setSearch, handleChange, value } = props;

    return (
        <Toolbar
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}
        >
            <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
            >
                <Grid item md={12} xs={12} sm={12}>
                    {/* <TextField
                        style={{ marginBottom: 5 }}
                        fullWidth
                        size="small"
                        name="search"
                        label="Recherche"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    /> */}
                </Grid>
            </Grid>
        </Toolbar >
    );
}

export interface IListeEtabProps {
    numerosTuteurs: any;
    listeTuteurs: any;
    handleClick: any;
    setNumerosTuteurs: (x: any) => void
}

export default function ListeTuteur2(props: IListeEtabProps) {
    const { numerosTuteurs, setNumerosTuteurs, handleClick, listeTuteurs } = props


    const [order, setOrder] = React.useState<Order>('asc');
    const [orderBy, setOrderBy] = React.useState<keyof Data>('message');
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const [value, setValue] = React.useState(1);

    const handleChange = (event: any) => {
        setValue((event.target as any).value);
    };

    //---------------------------------------------//
    const [search, setSearch] = React.useState('');
    const [filteredListeTuteurs, setFilteredTuteurs] = React.useState([...listeTuteurs]);

    const filterFunction = () => {
        if (search.length === 0) {
            setFilteredTuteurs([...listeTuteurs]);
        } else {
            const result = listeTuteurs.filter((item: any) => {
                const value = `${item.nomEleve} ${item.numeroCellulaire} ${item.prenomEleve} ${item.libelleClasseCourt} ${item.matricule}`;
                return value.toLowerCase().includes(search.toLowerCase());
            });
            setFilteredTuteurs(result);
        }
    };

    React.useEffect(() => {
        filterFunction();
    }, [search, listeTuteurs]);
    //--------------------------------------------//

    const handleRequestSort = (
        event: React.MouseEvent<unknown>,
        property: keyof Data,
    ) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected = filteredListeTuteurs.map((n: any) => n.codeEtab)
            setNumerosTuteurs(newSelected);
            return;
        }
        setNumerosTuteurs([]);
    };

    // const handleClick = (event: React.MouseEvent<unknown>, id: string) => {
    //     const selectedIndex = numerosTuteurs.indexOf(id);
    //     let newSelected: readonly string[] = [];

    //     if (selectedIndex === -1) {
    //         newSelected = newSelected.concat(numerosTuteurs, id);
    //     } else if (selectedIndex === 0) {
    //         newSelected = newSelected.concat(numerosTuteurs.slice(1));
    //     } else if (selectedIndex === numerosTuteurs.length - 1) {
    //         newSelected = newSelected.concat(numerosTuteurs.slice(0, -1));
    //     } else if (selectedIndex > 0) {
    //         newSelected = newSelected.concat(
    //             numerosTuteurs.slice(0, selectedIndex),
    //             numerosTuteurs.slice(selectedIndex + 1),
    //         );
    //     }
    //     setNumerosTuteurs(newSelected);
    // };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDense(event.target.checked);
    };

    const isSelected = (id: string) => numerosTuteurs.indexOf(id) !== -1;

    // Avoid a layout jump when reaching the last page with empty listeTuteurs. 
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredListeTuteurs.length) : 0;


    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2, backgroundColor: "#fcfafc", height: "40vh", overflow: "auto" }}>
                {filteredListeTuteurs.length === 0
                    ? <p style={{ display: "flex", justifyContent: "center" }}>Chargement de données...</p>
                    : <>
                        <EnhancedTableToolbar
                            numSelected={numerosTuteurs.length}
                            search={search}
                            setSearch={setSearch}
                            handleChange={handleChange}
                            value={value}
                        />
                        <div style={{ height: "30vh", overflow: "auto" }}>
                            <TableContainer>
                                <Table
                                    sx={{ minWidth: 750 }}
                                    aria-labelledby="tableTitle"
                                    size={"small"}
                                >
                                    <EnhancedTableHead
                                        numSelected={numerosTuteurs.length}
                                        order={order}
                                        orderBy={orderBy}
                                        onSelectAllClick={handleSelectAllClick}
                                        onRequestSort={handleRequestSort}
                                        rowCount={filteredListeTuteurs.length}
                                        filteredListeTuteurs={filteredListeTuteurs}
                                    />
                                    <TableBody>
                                        {
                                            filteredListeTuteurs.map((row: IListeTuteur, index: number) => {
                                                const isItemSelected = isSelected(row.numeroCellulaire);
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return (
                                                    <TableRow
                                                        hover
                                                        onClick={(event) => handleClick(event, row.numeroCellulaire)}
                                                        role="checkbox"
                                                        aria-checked={isItemSelected}
                                                        tabIndex={-1}
                                                        key={index}
                                                        sx={{ cursor: 'pointer' }}
                                                    >
                                                        <TableCell padding="checkbox">
                                                            <Checkbox
                                                                color="primary"
                                                                checked={isItemSelected}
                                                                inputProps={{
                                                                    'aria-labelledby': labelId,
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell
                                                            component="th"
                                                            id={labelId}
                                                            scope="row"
                                                            padding="none"
                                                            style={{ color: "GrayText" }}
                                                        >
                                                            {`${row.nomEleve} ${row.prenomEleve} - ${row.matricule} - ${row.libelleClasseCourt} - ${row.numeroCellulaire}`}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                        {emptyRows > 0 && (
                                            <TableRow
                                                style={{
                                                    height: (dense ? 33 : 53) * emptyRows,
                                                }}
                                            >
                                                <TableCell colSpan={6} />
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={filteredListeTuteurs.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </div>
                    </>
                }
            </Paper>
        </Box>
    );
}
